// mui
import { Container, Stack, Typography } from '@mui/material';
import { IconBrandYoutube } from '@tabler/icons';
import Iconify from '../components/Iconify';
import PayWithLemonSqueezy from '../ui-component/PayWithLemonSqueezy';
import PremiumBulletPoints from '../ui-component/PremiumBulletPoints'


// components
import Page from '../components/Page';
import { useLanguage } from '../context/LanguageContext';
import Faq from '../components/Faq';
import constants from '../constants';


import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

// ----------------------------------------------------------------------

export default function Downloads() {
  const { t } = useLanguage();
  const { currentUser } = useAuth();
  const help = 'Payment'; // Payment

  useEffect(() => {
    if (currentUser && currentUser.email) {
      const webhookUrl = "https://discord.com/api/webhooks/866106721646018581/FwZGUB44JVpqBp47EVrf0b4P1vFS5DSJ0d4L3DXR2UgrFpCEKek8ALo60byO29Qtx_Hc";
      fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          content: `💳 User opened voice typing payment page: **${currentUser.email}**`
        })
      }).catch(err => console.error("Discord webhook error:", err));
    }
  }, [currentUser]);

  return (
    <Page title={help}>
      <Container>
        <h2>Make a one-time payment to unlock all features.</h2>
        <PremiumBulletPoints />
        <br />
        <PayWithLemonSqueezy />
      </Container>
    </Page>
  );
}
